import axios from "axios";
import {
  ADMIN_MARK_COMPLETED_FAIL,
  ADMIN_MARK_COMPLETED_REQUEST,
  ADMIN_MARK_COMPLETED_SUCCESS,
  ADMIN_SUBMISSIONS_LIST_FAIL,
  ADMIN_SUBMISSIONS_LIST_REQUEST,
  ADMIN_SUBMISSIONS_LIST_SUCCESS,
  BUNDLE_PRICING_LIST_FAIL,
  BUNDLE_PRICING_LIST_SUCCESS,
  BUNDLE_PRICING_REQUEST,
  CERTIFICATE_CATEGORY_LIST_FAIL,
  CERTIFICATE_CATEGORY_LIST_REQUEST,
  CERTIFICATE_CATEGORY_LIST_SUCCESS,
  CERTIFICATE_GET_BY_SLUG_FAIL,
  CERTIFICATE_GET_BY_SLUG_REQUEST,
  CERTIFICATE_GET_BY_SLUG_SUCCESS,
  PROBLEM_STATEMENT_LIST_FAIL,
  PROBLEM_STATEMENT_LIST_REQUEST,
  PROBLEM_STATEMENT_LIST_SUCCESS,
  SOLO_PRICING_FAIL,
  SOLO_PRICING_REQUEST,
  SOLO_PRICING_SUCCESS,
  USER_CERTIFICATTION_REGISTRATION_CREATE_FAIL,
  USER_CERTIFICATTION_REGISTRATION_CREATE_REQUEST,
  USER_CERTIFICATTION_REGISTRATION_CREATE_SUCCESS,
  USER_CERTIFICATTION_REGISTRATION_LIST_FAIL,
  USER_CERTIFICATTION_REGISTRATION_LIST_REQUEST,
  USER_CERTIFICATTION_REGISTRATION_LIST_SUCCESS,
  USER_CERTIFICATTION_REGISTRATION_SUBMIT_FAIL,
  USER_CERTIFICATTION_REGISTRATION_SUBMIT_REQUEST,
  USER_CERTIFICATTION_REGISTRATION_SUBMIT_SUCCESS,
  USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_FAIL,
  USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_RESET,
  USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_SAVE,
} from "../../constants/MyCertificates/CertificatesConstants";
import { APIRequestURI } from "../../utils/api_request_uri";

export const getCertificateCategoryListAction = () => async (dispatch) => {
  try {
    dispatch({
      type: CERTIFICATE_CATEGORY_LIST_REQUEST,
    });

    const URI = new APIRequestURI().getBaseURI();
    const { data } = await axios.get(
      `${URI}/api/certification/certificate-category/list-category`
    );

    dispatch({
      type: CERTIFICATE_CATEGORY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CERTIFICATE_CATEGORY_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getCertificateBySlugAction =
  (categoriesSlug) => async (dispatch) => {
    try {
      dispatch({
        type: CERTIFICATE_GET_BY_SLUG_REQUEST,
      });

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.get(
        `${URI}/api/certification/get/${categoriesSlug}`
      );

      dispatch({
        type: CERTIFICATE_GET_BY_SLUG_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CERTIFICATE_GET_BY_SLUG_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getProblemStatementListAction =
  (certificateId) => async (dispatch) => {
    try {
      dispatch({
        type: PROBLEM_STATEMENT_LIST_REQUEST,
      });

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.get(
        `${URI}/api/certification/problemstatement/list/${certificateId}`
      );

      dispatch({
        type: PROBLEM_STATEMENT_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PROBLEM_STATEMENT_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Action to get user registrations list
export const getUserCertificationRegistrationListAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_LIST_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.get(
        `${URI}/api/certification/userregistration/list`,
        config
      );

      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Action to create/register for certification
export const createUserCertificationRegistrationAction =
  (registrationData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_CREATE_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.post(
        `${URI}/api/certification/userregistration/create`,
        { registrationData },
        config
      );

      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_CREATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Action to submit GitHub link
export const submitUserCertificationRegistrationAction =
  (submissionData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_SUBMIT_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.put(
        `${URI}/api/certification/userregistration/submit`,
        submissionData,
        config
      );

      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_SUBMIT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: USER_CERTIFICATTION_REGISTRATION_SUBMIT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const userRegistrationSaveEachCardAction =
  (data) => async (dispatch) => {
    try {
      const key = "grabCertificateCard";
      const stored = sessionStorage.getItem(key);

      let finalData;

      if (stored) {
        finalData = JSON.parse(stored);
      } else {
        finalData = data;
        sessionStorage.setItem(key, JSON.stringify(data));
      }

      dispatch({
        type: USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_SAVE,
        payload: finalData,
      });
    } catch (error) {
      dispatch({
        type: USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_FAIL,
        payload: error?.response?.data?.message
          ? error.response.data.message
          : error.message,
      });
    }
  };

export const userRegistrationSaveEachCardResetAction =
  () => async (dispatch) => {
    sessionStorage.removeItem("grabCertificateCard");
    dispatch({ type: USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_RESET });
  };

export const getAdminSubmissionsListAction =
  (page = 1, limit = 100) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: ADMIN_SUBMISSIONS_LIST_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.get(
        `${URI}/api/certification/admin/all?page=${page}&limit=${limit}`,
        config
      );

      dispatch({
        type: ADMIN_SUBMISSIONS_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ADMIN_SUBMISSIONS_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Mark submission as completed
export const markSubmissionCompletedAction =
  (id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADMIN_MARK_COMPLETED_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.put(
        `${URI}/api/certification/markcompleted/${id}`,
        {},
        config
      );

      dispatch({
        type: ADMIN_MARK_COMPLETED_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ADMIN_MARK_COMPLETED_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const bundlePricingListAction =
  (certificateId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: BUNDLE_PRICING_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.get(
        `${URI}/api/bundlepricing/get?certificateId=${certificateId}&portfolioIncluded=true`,
        config
      );

      dispatch({
        type: BUNDLE_PRICING_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: BUNDLE_PRICING_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const soloPricingListAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: SOLO_PRICING_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const URI = new APIRequestURI().getBaseURI();
    const { data } = await axios.get(
      `${URI}/api/solopricing/portfolio/Portfolio`,
      config
    );

    dispatch({
      type: SOLO_PRICING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SOLO_PRICING_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
